import { type FlipperFlagValues, type ProductFlagValues, ProductFlipperFlagService } from './ProductFlipperFlag.service';
import type { ProductFlag } from './constants/productFlipperFlagRelation';

export class ProductFlagService {
  isProductFlagEnabled(
    productFlagName: ProductFlag,
    productFlags: FlipperFlagValues,
    flipperFlags: ProductFlagValues
  ): boolean {
    const productFlipperFlagService = new ProductFlipperFlagService();
    const mergedFlags = productFlipperFlagService.mergeFlags(
      productFlags,
      productFlipperFlagService.getFlipperOverridesForProductFlags(flipperFlags)
    );
    return Boolean(mergedFlags[productFlagName]);
  }
}
